/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
 */
export interface JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody {
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody
     */
    userID: string;
}

/**
 * Check if a given object implements the JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody interface.
 */
export function instanceOfJumboPostwizercompanyenablePostWizerCompanyEnableRequestBody(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "firstName" in value;
    isInstance = isInstance && "lastName" in value;
    isInstance = isInstance && "userID" in value;

    return isInstance;
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableRequestBodyFromJSON(json: any): JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody {
    return JumboPostwizercompanyenablePostWizerCompanyEnableRequestBodyFromJSONTyped(json, false);
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'email': json['email'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'userID': json['userID'],
    };
}

export function JumboPostwizercompanyenablePostWizerCompanyEnableRequestBodyToJSON(value?: JumboPostwizercompanyenablePostWizerCompanyEnableRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyName': value.companyName,
        'email': value.email,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'userID': value.userID,
    };
}

